import { StoreConfig } from "@CommonTypes/backend/FilterConfig";
import { MerchflowFilterStore } from "@CommonApi/merchflows/filters";

export const mapFilterStoreToStoreConfig = (s: MerchflowFilterStore): StoreConfig => ({
  store: s.store,
  template_id: s.templateId,
  cluster: s.cluster,
  section_height: s.sectionHeight,
  section_width: s.sectionWidth,
  state: s.state,
  bay_size: s.baySize,
  category_code: s.categoryCode,
  retailer_category_code: s.retailerCategoryCode,
});
